import isEqual from 'lodash.isequal';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import FilterButton from '@/components/FilterDropdown/FilterButton';
import useOnClickOutside from '@/hooks/useOnClickOutside';
import { initialState } from '@/models/filters';
import { RootState } from '@/utils/store';

import FreelancersFilterBox from './FreelancersFilterBox';

const FreelancersFilter = () => {
  const [showFilter, setShowFilter] = useState(false);

  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => setShowFilter(false));

  const currentFilters = useSelector(
    (state: RootState) => state.filters.filters.freelancerFilters,
  );

  const defaultFilters = initialState.filters.freelancerFilters;

  const filterApplied = !isEqual(currentFilters, defaultFilters);

  return (
    <div ref={ref}>
      <FilterButton
        onClick={() => {
          setShowFilter(!showFilter);
        }}
        isActive={!!showFilter}
        filterApplied={filterApplied}
      ></FilterButton>
      {showFilter && (
        <FreelancersFilterBox closeFilter={() => setShowFilter(false)} />
      )}
    </div>
  );
};

export default FreelancersFilter;
